var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavoriteHeartSummary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 37,
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 37 37",
    style: {
      enableBackground: "new 0 0 37 37"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#9D70D8;stroke:#FFFFFF;stroke-width:2;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M18.6,10.4l-0.7-0.7L17,8.8C14.1,6,9.5,6,6.6,8.8c-2.4,2.4-2.9,6.3-1,10.9l0,0c1.1,2.7,3.1,5.6,5.5,7.8 s5.1,3.6,7.5,3.6s5.1-1.4,7.5-3.6s4.4-5,5.5-7.8l0,0c1.9-4.6,1.4-8.5-1-10.9C27.7,6,23.1,6,20.2,8.8L18.6,10.4z M18.6,10.4l0.7-0.7 l0.9-0.9L18.6,10.4z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteHeartSummary);
export default __webpack_public_path__ + "static/media/favorite-heart-summary.aa6b94cd9aeecc90350c24c47ce309ab.svg";
export { ForwardRef as ReactComponent };